import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getPolicyHolder } from "../../../redux/slice/claim/claimSlice";
import { BounceLoader } from "react-spinners";
import { useLocation } from "react-router-dom";

const PolicyHolder = ({ setTab, policyInfo, setPolicyInfo }) => {
  const { user } = useSelector((state) => state?.auth?.user);
  const { policyHolder, isLoading } = useSelector((state) => state?.claim);
  const [searched, setSearched] = useState(false);
  const dispatch = useDispatch();

  const { state } = useLocation();

  const onSubmit = (values) => {
    const payload = {
      office_id: user?.office_id,
      policy_number: values.policy_no,
    };
    dispatch(getPolicyHolder(payload));
    setSearched(true);
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      policy_no: state ? state : "",
    },
    onSubmit,
  });

  useEffect(() => {
    // Check if state exists, and if it does, trigger the form submission
    if (state) {
      handleSubmit();
    }
  }, []);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='row mb-2'>
          <div className='col-md-4 col-lg-3 col-xl-2 text-right sm-text-end'>
            <label htmlFor='name' className='col-form-label'>
              Policy Number
            </label>
          </div>
          <div className='col-md-7 col-lg-6'>
            <div>
              <input
                type='text'
                className='form-control form-control-sm'
                id='policy_no'
                value={values?.policy_no}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors?.policy_no && touched?.policy_no && (
                <p className='mb-0 text-danger'>{errors?.policy_no + "*"}</p>
              )}
            </div>
          </div>
        </div>
        <div className='row mb-3 mt-2'>
          <div className='col-md-4 col-lg-3 col-xl-2'></div>
          <div className='col-md-7 col-lg-6'>
            <button
              type='submit'
              className='btn btn-primary btn-sm px-4 rounded'
              disabled={!values.policy_no}
            >
              <span>Search</span>
            </button>
          </div>
        </div>
      </form>
      {policyHolder?.app_details && !isLoading && (
        <div className='row'>
          <div className='col-md-12 col-lg-10'>
            <div className='row mt-3'>
              <div className='col-md-6 mt-2 '>
                <span className='fw-bold me-2'>Customer Name: </span>
                <span>
                  {policyHolder?.app_details?.customerFirstName}{" "}
                  {policyHolder?.app_details?.customerLastName}
                </span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Customer Id: </span>
                <span>{policyHolder?.app_details?.customerId}</span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Marketer/Agent: </span>
                <span>
                  {policyHolder?.app_details?.agentFirstName}{" "}
                  {policyHolder?.app_details?.agentLastName}
                </span>
              </div>
              <div className='col-md-6 mt-2 '>
                <span className='fw-bold me-2'>Policy No: </span>
                <span>{policyHolder?.app_details?.policyAppNumber}</span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Policy Name: </span>
                <span>{policyHolder?.app_details?.policyName}</span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Status: </span>
                <span className='badge badge-success-lighten'>
                  {policyHolder?.app_details?.status === "2" && "Active"}
                </span>
                <span className='badge badge-warning-lighten'>
                  {policyHolder?.app_details?.status === "1" && "Pending"}
                </span>
                <span className='badge badge-info-lighten'>
                  {policyHolder?.app_details?.status === "3" && "Matured"}
                </span>
              </div>
              {/* <div className='col-md-6 mt-2'>
                        <span className='fw-bold me-2'>Sub Status: </span>
                        <span></span>
                    </div> */}
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Duration: </span>
                <span>{policyHolder?.app_details?.duration} months</span>
              </div>
              {policyHolder?.app_details?.discount && (
                <div className='col-md-6 mt-2'>
                  <span className='fw-bold me-2'>Discount: </span>
                  <span> {policyHolder?.app_details?.discount}%</span>
                </div>
              )}
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Effective Date: </span>
                <span>
                  {moment(policyHolder?.app_details?.effectiveDate).format(
                    "LL"
                  )}
                </span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>End Date: </span>
                <span>
                  {moment(policyHolder?.app_details?.endDate).format("LL")}
                </span>
              </div>
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Total Premium: </span>
                <span>
                  {" "}
                  &#8358;
                  {parseFloat(policyHolder?.app_details?.totalPremium).toFixed(
                    2
                  )}
                </span>
              </div>
              {policyHolder?.app_details?.butCharge && (
                <div className='col-md-6 mt-2'>
                  <span className='fw-bold me-2'>But-Charge: </span>
                  <span>
                    {" "}
                    &#8358;{parseInt(policyHolder?.app_details?.butCharge)}
                  </span>
                </div>
              )}
              <div className='col-md-6 mt-2'>
                <span className='fw-bold me-2'>Renewal Date: </span>
                <span>
                  {moment(policyHolder?.app_details?.endDate).format("LL")}
                </span>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-end pt-5'>
            {/* <button
                    type='button'
                    className='btn btn-sm btn-info text-white me-3'
                    //   onClick={() => accountingRef?.current?.click()}
                >
                    <i className='mdi mdi-arrow-left me-1'></i>
                    Previous
                </button> */}
            <button
              onClick={() => setTab("cover_info")}
              className='btn btn-primary text-white px-4 btn-sm'
            >
              Next
            </button>
          </div>
        </div>
      )}
      {isLoading && (
        <div
          className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
          style={{ height: "100%" }}
        >
          <div className='mx-auto'>
            <BounceLoader
              color='#090b8f'
              loading={true}
              // cssOverride={override}
              size={50}
              aria-label='Loading Spinner'
              data-testid='loader'
              className='ms-3'
            />
            <span className='fw-bolder text-primary-1 ms-2'>
              Please wait...
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PolicyHolder;
